import { CircleNotch } from "@phosphor-icons/react";

// Full-container placeholder shown while a page's primary data loads, so the
// page does not flash its empty/partial state before the data arrives.
export const LoadingPanel = () => (
  <div className="flex min-h-[calc(100vh-13rem)] items-center justify-center">
    <CircleNotch size={28} className="animate-spin opacity-40" />
  </div>
);
